import React, { useRef } from "react";
import { createPortal } from "react-dom";

import { useEscapeKey, useModalA11y } from "../../hooks";
import { Backdrop, SheetGroup } from "./styles";
import { BottomActionSheetProps } from "./types";

const modalElement = document.getElementById("modal-root") as HTMLElement;

export const BottomActionSheet: React.FC<BottomActionSheetProps> = ({
  isOpen,
  onClose,
  ariaLabel,
  children,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEscapeKey(onClose, isOpen);
  useModalA11y(isOpen, containerRef);

  if (!isOpen) {
    return null;
  }

  const stop = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  return createPortal(
    <Backdrop onClick={onClose}>
      <SheetGroup
        ref={containerRef}
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
        onClick={stop}
      >
        {children}
      </SheetGroup>
    </Backdrop>,
    modalElement,
  );
};
